import React from "react";
import "./LinkedInShare.css"; // Make sure to import the CSS file

const LinkedInAppInstructions = () => {
    return (
        <div className="linkedin-instructions">
            <p>
                By default, posts will be made by KonfHub App on your behalf. The attached screenshot shows the permission requested for this.
            </p>
            <p>
                If you wish to white label this, you need to create an app on LinkedIn. The company you select during the app setup will function as the publisher, and posts will be made by them instead of KonfHub.
            </p>
            <div className="linkedin-instructions-title">Follow the steps below to create an app on LinkedIn:</div>
            <ol style={{ paddingLeft: "20px" }}>
                <li>Go to <a href="https://developer.linkedin.com" target="_blank" rel="noopener noreferrer">developer.LinkedIn.com</a>.</li>
                <li>Click My apps in the upper-right corner of the page.</li>
                <li>Click Create app in the upper-right corner of the page.</li>
                <li>On the Create an app page, enter your app name in the App name box.</li>
                <li>In the LinkedIn Page box, enter your company page name or URL. (If you don’t have a LinkedIn Page, you can create one by clicking Create a new LinkedIn Page)</li>
                <li>In the Privacy policy URL box, enter your privacy policy URL.</li>
                <li>Click the Upload a logo button to upload an image that is displayed to users when they authorize with your app.</li>
                <li>Select the I have read and agree to these terms checkbox.</li>
                <li>Click the Create app button. Your new app is created and is available under the My apps tab.</li>
                <li>
                    Go to Products tab for the newly created App, Request Access for the following Products:
                    <ol type="a" style={{ paddingLeft: "20px" }}>
                        <li>Share on LinkedIn</li>
                        <li>Sign In with LinkedIn using OpenID Connect</li>
                    </ol>
                </li>
            </ol>
        </div>
    );
};

export default LinkedInAppInstructions;
